exports.handleFetchResponse = (r) => {
    if (!r.ok) {
        try {
            r.json().then((err) => {
                if (err.error === 1) {
                    this.setCookie('AID', '', -1)
                    window.location = '/assessment'
                }
            })
        } catch (e) {}
    } else {
        return r.json()
    }
}

exports.handleErrors = (err) => {
    document.getElementById('form-container').classList.remove('invisible')
    // console.log(err)
}

/**
 * A safe way of retrieving a value and knowing whether the value exists and removing unwanted 'undefined' responses.
 *
 * @param {*} data The data to be processed.
 * @param {String} position Nullable. The string to process to get to the value in question.
 * @param {Boolean} defaultValue Nullable. Returns this value if it's null.
 * @returns
 */
exports.getValue = (data, position = null, defaultValue = null) => {
    try {
        // If the position string is not null.
        if (position !== null) {
            // Split the position string by the '.' symbols and increment through them.
            position.split('.').forEach((k) => {
                // Try and push the data object forward. Traversing through the object and it's subobjects.
                data = data[k]
            })
        }
        // If the item is a string, trim any extra spaces.
        if (typeof data === 'string') data = data.trim()
        // If the data is not undefined then return it, else return null.
        return data !== undefined ? data : defaultValue
    } catch (e) {
        // If the function fails return null.
        return defaultValue
    }
}

exports.getCookie = (name) => {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
    return null
}

exports.setCookie = (name, value, expiry, checkCookie) => {
    if (checkCookie) {
        const consent = JSON.parse(getCookie('CookieConsent'))
        if (!consent || !consent.personalisation) return
    }

    let cookieString = name + '=' + value + ';path=/;'
    if (expiry) {
        var now = new Date()
        var time = now.getTime()
        var expireTime = time + expiry
        now.setTime(expireTime)

        cookieString += 'expires=' + now.toUTCString() + ';'
    }

    if (process.env.NEXT_PUBLIC_ENVIRONMENT !== 'local') {
        cookieString += 'domain=.taxd.co.uk;'
    }

    document.cookie = cookieString
}
/**
 * Automatically removes the cookie depending on the environment that is in use.
 *
 * @param {String} name The name of the cookie to remove.
 */
exports.removeCookie = (name) => {
    if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'local') {
        document.cookie = `${name}=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`
    } else {
        document.cookie = `${name}=;path=/;domain=.taxd.co.uk;expires=Thu, 01 Jan 1970 00:00:01 GMT`
    }
}

/**
 * Formats a number as a currency.
 *
 * @param {Number} number The number to format.
 * @param {Boolean} decimals Whether to include decimals.
 */
exports.formatCurrency = (number, decimals = true) => {
    if (number === 0 || number == undefined) {
        return '-'
    }

    if (!decimals) {
        number = Math.round(number)
    }

    let num = `${number < 0 ? '-' : ''}£${number < 0 ? number * -1 : number}`
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

exports.formatCurrencyFull = (number, includePound = true, includePence = true) => {
    var formatter = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
    })
    let figure = formatter.format(number)
    if (!includePound) figure = figure.replace('£', '')
    if (!includePence) figure = figure.replace(/(\.|,)00$/g, '')
    return figure
}

const fallbackCopyTextToClipboard = (text) => {
    let textArea = document.createElement('textarea')
    textArea.value = text
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
        let successful = document.execCommand('copy')
        let msg = successful ? 'successful' : 'unsuccessful'
    } catch (err) {}

    document.body.removeChild(textArea)
}

exports.copyTextToClipboard = (text, includeAlert = false) => {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text)
        return
    }
    navigator.clipboard.writeText(text).then(
        function () {
            console.log('Copying to clipboard was successful!')
            if (includeAlert) {
                alert('Copied!')
            }
        },
        function (err) {
            console.error('Could not copy text: ', err)
            if (includeAlert) {
                alert("Couldn't copy text.")
            }
        }
    )
}

exports.getDomain = (domain = 'dashboard') => {
    switch (process.env.NEXT_PUBLIC_ENVIRONMENT) {
        case 'local':
            return 'http://localhost:3000'
        case 'dev':
            return `https://${domain}-dev.taxd.co.uk`
        case 'qa':
            return `https://${domain}-qa.taxd.co.uk`
        case 'prod':
            return `https://${domain}.taxd.co.uk`
    }
}
